import { SvgIconProps } from '@traba/types'

export default function Replace({
  size,
  color = '#7A8A99',
  strokeWidth = 2,
  ...props
}: SvgIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Top right rectangle */}
      <rect
        x="14"
        y="3"
        width="7"
        height="6"
        rx="1.5"
        stroke={color}
        strokeWidth={strokeWidth}
      />
      {/* Bottom left rectangle */}
      <rect
        x="3"
        y="15"
        width="7"
        height="6"
        rx="1.5"
        stroke={color}
        strokeWidth={strokeWidth}
      />
      {/* Arrow pointing down-left (from top to bottom) */}
      <path
        d="M11 6C8 6 6 8 6 11L6 13"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M3 11L6 14L9 11"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Arrow pointing up-right (from bottom to top) */}
      <path
        d="M13 18C16 18 18 16 18 13L18 11"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M21 13L18 10L15 13"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
